import { useEffect, useState } from 'react'

// Device detection based on touch capability, user agent, and aspect ratio
// Rather than pixel width thresholds (which fail for high-res iPads)

function getDeviceType() {
  const width = window.innerWidth
  const height = window.innerHeight
  const isPortrait = height > width
  const isLandscape = width >= height
  const aspectRatio = width / height
  
  // Check if device has touch capability
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  
  // Check user agent for tablet indicators
  const ua = navigator.userAgent.toLowerCase()
  const isIPad = ua.includes('ipad') || (ua.includes('macintosh') && hasTouch)
  const isAndroidTablet = ua.includes('android') && !ua.includes('mobile')
  const isTabletUA = isIPad || isAndroidTablet
  
  let deviceType = 'desktop'
  
  // If it's a known tablet by user agent, always treat as tablet
  if (isTabletUA) {
    deviceType = 'tablet'
  }
  // Otherwise, use aspect ratio heuristics for touch devices
  else if (hasTouch) {
    if (aspectRatio <= 1.8) {
      // Portrait or moderate landscape — use aspect ratio to split phone/tablet
      deviceType = aspectRatio < 0.75 ? 'phone' : 'tablet'
    } else {
      // Wide landscape (aspectRatio > 1.8) — could be a phone on its side.
      // Use the physical short dimension (orientation-independent) to decide:
      // phones typically have a short dimension ≤ 500px; tablets are 768px+.
      const minDim = Math.min(screen.width, screen.height)
      deviceType = minDim <= 500 ? 'phone' : 'tablet'
    }
  }
  // No touch = desktop
  else {
    deviceType = 'desktop'
  }

  return {
    deviceType,
    orientation: isPortrait ? 'portrait' : 'landscape',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
    isPhone: deviceType === 'phone',
    isPortrait,
    isLandscape,
    aspectRatio
  }
}

export function useDeviceType() {
  const [state, setState] = useState(getDeviceType())

  useEffect(() => {
    function handleResize() {
      setState(getDeviceType())
    }
    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
    }
  }, [])

  // Device type detection active (logs disabled for mobile compatibility)

  return state
}
